const SidebarFilter = () => {
  const intersection = (arr1, arr2) => {
    return arr1.filter(item => arr2.includes(item));
  };

  const intersectMany = (...arrs) => {
    return arrs.reduce((acc, curr) => intersection(acc, curr));
  };

  const initSidebarFilter = container => {
    if (!container) return null;

    const app = {
      container,
      groups: [],
      selected: [],
      filtering: false,

      init() {
        this.filterGroups = this.container.querySelectorAll('[filter-group]');
        this.filterToggles = this.container.querySelectorAll('[filter-toggle]');

        this.filterGroups.forEach(group => {
          this.selected.push({ handle: group.dataset.group, filters: [] });
        });

        this.filterToggles.forEach(toggle => {
          toggle.addEventListener('click', () => this.toggleFilter(toggle));
        });

        this.checkCollection();
        this.checkHash();
        this.filter();
      },

      checkHash() {
        const hash = window.location.hash;
        if (!hash.includes('tag-filter')) return;

        const filterGroups = hash.replace('#tag-filter=', '').split('|');
        filterGroups.forEach(group => {
          const [handle, filtersStr] = group.split('=');
          const filters = filtersStr.split(',').map(filter => `${handle}_${filter}`);
          const selection = this.selected.find(selected => selected.handle === handle);
          if (selection) {
            selection.filters.push(...filters);
          }
        });
      },

      checkCollection() {
        const path = window.location.pathname;
        if (!path.includes('collections')) return;

        const collection = path.split('/').pop();
        const filterElement = document.querySelector(`[data-filter-without-group="${collection}"]`);
        if (!filterElement) return;

        const { group: handle, filter } = filterElement.dataset;
        const selection = this.selected.find(selected => selected.handle === handle);
        if (selection) selection.filters.push(filter);
      },

      toggleFilter(el) {
        const { group, filter } = el.dataset;
        const selectedGroup = this.selected.find(item => item.handle === group);
        if (!selectedGroup) return;

        const filterIndex = selectedGroup.filters.indexOf(filter);
        if (filterIndex === -1) {
          selectedGroup.filters.push(filter);
        } else {
          selectedGroup.filters.splice(filterIndex, 1);
        }
        this.filter();
      },

      filter() {
        document.querySelectorAll('[filter-toggle]').forEach(el => el.classList.remove('active'));
        const cids = [];
        this.filtering = false;

        this.selected.forEach(group => {
          const groupCids = [];
          group.filters.forEach(filter => {
            document.querySelectorAll(`[data-group="${group.handle}"][data-filter="${filter}"]`).forEach(el => el.classList.add('active'));

            document.querySelectorAll('[mx-filter-results] [filter-result]').forEach(el => {
              if (el.classList.contains(filter)) {
                groupCids.push(parseInt(el.dataset.productId, 10));
              }
            });
          });

          if (groupCids.length > 0) {
            cids.push(groupCids);
            this.filtering = true;
          }
        });

        const filteredCids = this.filtering ? intersectMany(...cids) : null;

        document.querySelectorAll('[mx-filter-results] [filter-result]').forEach(el => {
          el.style.display = !this.filtering || filteredCids.includes(parseInt(el.dataset.productId, 10)) ? 'block' : 'none';
        });

        document.dispatchEvent(new CustomEvent('mx_sidebar_filter.filtered', { detail: { data: this } }));
        this.updateHash();
      },

      updateHash() {
        if (!this.filtering) {
          window.location.hash = window.location.pathname;
          return;
        }

        const groups = this.selected
          .filter(selection => selection.filters.length > 0)
          .map(selection => {
            const filters = selection.filters.map(filter => filter.replace(selection.handle, '').replace('_', '')).join(',');
            return `${selection.handle}=${filters}`;
          });

        if (groups.length > 0) {
          window.location.hash = `#tag-filter=${groups.join('|')}`;
        }
      },
    };

    return app;
  };

  const sidebarFilterElement = document.querySelector('[mx-sidebar-filter]');
  if (sidebarFilterElement) {
    const sidebarFilter = initSidebarFilter(sidebarFilterElement);
    sidebarFilter?.init();
  }

  document.querySelector('.mobile-filter')?.addEventListener('click', () => {
    document.querySelector('.sidebar-filters')?.classList.toggle('open');
  });
}

export default SidebarFilter;